/**
 * Application configuration
 * For static sites, configuration is baked into the build
 */

export const config = {
  /**
   * Google Analytics Measurement ID
   * This is a public value that appears in client-side code
   * Set to empty string to disable analytics
   */
  googleAnalyticsMeasurementId: 'G-PY4LGVHWXR'
} as const
